<template>
  <layout :links="[{ href: `Login`, label: $t(`login.title`) }, { href: `AnswerWithCode`, label: $t(`login.answerCode`) }]">
    <div v-if="me && !loading">
      <button type="button" class="ibtn" style="width: 100%; margin: .5rem 0;" @click="goToHome">{{$t(`login.continueAs`, { firstname: me.firstname, lastname: me.lastname })}}</button>
      <p class="subtitle">{{$t(`login.connectToDifferentAccount`)}}</p>
    </div>
    <div class="alert alert-danger" role="alert" v-if="invalid">
      {{$t(`login.invalid`)}}
    </div>
    <form @submit.prevent="login">
      <input class="form-control" type="email" v-model="email" :placeholder="$t(`login.email`)" required :disabled="loading" autocomplete="email">
      <input class="form-control" type="password" v-model="password" :placeholder="$t(`login.password`)" required :disabled="loading" autocomplete="current-password">
      <div class="form-button">
        <button id="submit" type="submit" class="ibtn" :disabled="!canLogin || loading">{{loginText}}</button> <router-link :to="{ name: `Reset` }">{{$t(`login.forget`)}}</router-link>
      </div>
    </form>
    <div class="other-links">
      <a href="#">{{$t(`login.sso`)}}</a>
    </div>
  </layout>
</template>

<script>
import Layout from './Layout';
import { mapState } from 'vuex';

export default {
  name: "Login",
  components: {
    Layout,
  },
  data () {
    return {
      email: ``,
      password: ``,
      badLogins: 0,
      loading: false,
      loginText: this.$t(`login.login`),
      invalid: false,
    };
  },
  computed: {
    ...mapState([
      `me`,
    ]),
    canLogin () {
      return Boolean(this.email) && Boolean(this.password);
    },
  },
  methods: {
    goToHome () {
      window.location.href = this.me.homeUrl;
    },
    async login () {
      this.loading = true;
      this.invalid = false;
      this.loginText = this.$t(`login.connecting`);
      const loginOk = await this.$store.dispatch(`login`, { email: this.email, password: this.password });
      await this.$store.dispatch(`fetchMe`);
      if (loginOk) {
        if (this.$route.query.r) {
          return window.location.href = this.$route.query.r;
        }
        return this.goToHome();
      } else {
        this.invalid = true;
        if (++this.badLogins === 3) {
          window.$crisp.push(["do", "message:show", ["text", this.$t(`login.needHelp`)]])
        }
      }
      this.loginText = this.$t(`login.login`);
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.subtitle {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-top: 1rem;
}
</style>
